export default function SpinHamiltonianVisual() {
  return <div>Spin Hamiltonian works</div>;
}